import React from 'react';
import PropTypes from 'prop-types';

import BaseInput from './BaseInput';

const TextWidget = props => {
  return <BaseInput {...props} />;
};

TextWidget.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TextWidget;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/TextWidget.js